// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2SvhI","content":"styles_content__11RmW","checkbox":"styles_checkbox__3iszn","checkboxLabel":"styles_checkboxLabel__2UqPY"};